import { createAction } from '@reduxjs/toolkit';
import { ColDef } from 'ag-grid-enterprise';
import { ViewModifyProgressState, type MDMMasterState, type Option } from '../../../VectorFlow/types/MDM';

const actions =  {
    STORE_ALL_MASTERS: createAction<MDMMasterState[]>("STORE_ALL_MASTERS"),
    FILL_MASTERS : createAction<MDMMasterState[]>("FILL_MASTERS"),
    REMOVE_MASTER:createAction<number>("REMOVE_MASTER"),
    FILTER_MASTER:createAction<number>("FILTER_MASTER"),
    ADD_MASTER:createAction<MDMMasterState>("ADD_MASTER"),
    SYNC_ACTIVE_MASTER_TO_MASTER:createAction("SYNC_ACTIVE_MASTER_TO_MASTER"),
    FILL_OPTIONS:createAction<Option[]>("FILL_OPTIONS"),
    FILL_SELECTED_OPTIONS:createAction<any>("FILL_SELECTED_OPTIONS"),
    UPDATE_ACTIVE_MASTER:createAction<number | MDMMasterState>("UPDATE_ACTIVE_MASTER"),
    TOGGLE_SELECT_MASTER_SCREEN:createAction<boolean>("TOGGLE_SELECT_MASTER_SCREEN"),
    ADD_COLDEFS:createAction<{colDefs:ColDef[]}>("ADD_COLDEFS"),
    UPDATE_COLDEFS:createAction<ColDef[]>("UPDATE_COLDEFS"),
    REMOVE_COLDEFS:createAction<string[]>("REMOVE_COLDEFS"),
    ADD_FILTER:createAction("ADD_FILTER"),
    REMOVE_FILTER:createAction<string>("REMOVE_FILTER"),
    REMOVE_ALL_FILTERS:createAction("REMOVE_ALL_FILTERS"),
    RESET_FILTERS:createAction("RESET_FILTER"),
    UPDATE_FILTER:createAction<{value:string,property:string,filterId:string}>("UPDATE_FILTER"),
    UPDATE_FILTER_VALUE:createAction<{value:string,property:string,filterId:string}>("UPDATE_FILTER_VALUE"),
    MODIFY_ROW_DATA:createAction<{oldRow:any[],newRow:any[]}>("MODIFY_ROW_DATA"),
    UPDATE_ROW_DATA:createAction<any[]>("UPDATE_ROW_DATA"),
    REMOVE_ROW_DATA:createAction<any[]>("REMOVE_ROW_DATA"),
    TOGGLE_UPLOAD_MODAL:createAction<boolean>("TOGGLE_UPLOAD_MODAL"),
    UPDATE_PROGRESS_STATE:createAction<ViewModifyProgressState>("UPDATE_PROGRESS_STATE"),
    RESET_STATE:createAction("RESET_STATE"),
    SET_DRAFT_ID:createAction<string>("SET_DRAFT_ID"),
    SET_RECORD_COUNT:createAction<number>("SET_RECORD_COUNT"),
    UPDATE_DATA_AVAILABILITY_STATUS:createAction<boolean>("UPDATE_DATA_AVAILABILITY_STATUS"),
    UPDATE_MASTER_CHECKED_STATUS:createAction<number>('UPDATE_MASTER_CHECKED_STATUS'),
    UPDATE_IS_SAVING_DRAFT:createAction<boolean>('UPDATE_IS_SAVING_DRAFT')
}

export const {
    STORE_ALL_MASTERS,
    FILL_MASTERS,
    REMOVE_MASTER,
    FILTER_MASTER,
    ADD_MASTER,
    SYNC_ACTIVE_MASTER_TO_MASTER,
    FILL_OPTIONS,
    FILL_SELECTED_OPTIONS,
    UPDATE_ACTIVE_MASTER,
    TOGGLE_SELECT_MASTER_SCREEN,
    ADD_COLDEFS,
    UPDATE_COLDEFS,
    REMOVE_COLDEFS,
    ADD_FILTER,
    REMOVE_FILTER,
    UPDATE_FILTER,
    REMOVE_ALL_FILTERS,
    RESET_FILTERS,
    UPDATE_ROW_DATA,
    MODIFY_ROW_DATA,
    REMOVE_ROW_DATA,
    UPDATE_PROGRESS_STATE,
    TOGGLE_UPLOAD_MODAL,
    RESET_STATE,
    SET_DRAFT_ID,
    SET_RECORD_COUNT,
    UPDATE_DATA_AVAILABILITY_STATUS,
    UPDATE_MASTER_CHECKED_STATUS,
    UPDATE_IS_SAVING_DRAFT,
    UPDATE_FILTER_VALUE
} = actions;